; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('artStatusBadge', artStatusBadge)

  /* @ngInject */
  function artStatusBadge () {
    return {
      restrict: 'E',
      scope: {
        status: '<',
        unavailable: '<',
        archived: '<',
        customizationLevel: '<',
        needApproval: '<'
      },
      templateUrl: '/arts/directives/art-status-badge/art-status-badge-directive.html?$$REVISION$$',
      controller: 'ArtStatusBadgeController'
    }
  }
})()
